import { render, staticRenderFns } from "./CannotViewComponent.vue?vue&type=template&id=a11a66d0&scoped=true&"
import script from "./CannotViewComponent.vue?vue&type=script&lang=js&"
export * from "./CannotViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11a66d0",
  null
  
)

export default component.exports